import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function BookingSummary({ pricing, formData, customerDebt }) {
  const debtActive = !!(customerDebt && customerDebt.auto_apply_active);
  const debtAmount = debtActive ? (customerDebt.surcharge_per_booking || 50) : 0;
  const dueNowWithDebt = (pricing.total_due_now || 0) + debtAmount;
  return (
    <Card className="shadow-xl border-0 rounded-3xl sticky top-8">
      <CardHeader className="bg-green-600 text-white rounded-t-3xl">
        <CardTitle className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Booking Summary
        </CardTitle>
      </CardHeader>
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Trip Price ({formData.num_passengers} pax)</span>
            <span className="font-semibold">${pricing.trip_price.toFixed(2)}</span>
          </div>
          {pricing.shipping_savings > 0 && (
            <div className="flex justify-between text-sm text-green-600">
              <span>T&M Courier Savings</span>
              <span className="font-semibold">-${pricing.shipping_savings.toFixed(2)}</span>
            </div>
          )}
          {formData.trip_type === "return" && pricing.luggage_fee > 0 && (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Extra Luggage ({Math.max(0, formData.total_suitcases - 1)})</span>
              <span className="font-semibold">${pricing.luggage_fee.toFixed(2)}</span>
            </div>
          )}
          <div className="border-t pt-4">
            <div className="flex justify-between text-sm text-muted-foreground">
              <span>Deposit (${pricing.deposit_per_person || 20}/person × {formData.num_passengers})</span>
              <span>${pricing.deposit.toFixed(2)}</span>
            </div>
            {pricing.luggage_fee > 0 && (
              <div className="flex justify-between text-sm text-muted-foreground">
                <span>+ Luggage fee</span>
                <span>${pricing.luggage_fee.toFixed(2)}</span>
              </div>
            )}
            {debtActive && (
              <div className="flex justify-between text-sm text-red-700 font-semibold" data-testid="summary-debt-line">
                <span>+ Prior balance settlement</span>
                <span>${debtAmount.toFixed(2)}</span>
              </div>
            )}
          </div>
          <div className="border-t pt-4">
            <div className="flex justify-between text-lg">
              <span className="font-bold">Full Trip Total</span>
              <span className="font-extrabold text-emerald-900" data-testid="summary-full-trip-total">
                ${((pricing.trip_price || 0) + (pricing.luggage_fee || 0) + debtAmount).toFixed(2)}
              </span>
            </div>
            <div className="flex justify-between text-sm text-muted-foreground mt-1">
              <span>{pricing.pay_full_trip ? "You'll pay now" : "Deposit to reserve now"}</span>
              <span className="font-semibold">${dueNowWithDebt.toFixed(2)}</span>
            </div>
            {!pricing.pay_full_trip && (
              <p className="text-xs text-amber-800 mt-2 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1.5">
                <span className="font-bold">Balance to driver at pickup:</span> $
                {((pricing.trip_price || 0) + (pricing.luggage_fee || 0) + debtAmount - dueNowWithDebt).toFixed(2)} — full trip stays owed until the deposit is verified.
              </p>
            )}
          </div>
        </div>

        <div className="mt-6 p-4 bg-yellow-50 rounded-xl border border-yellow-200">
          <p className="text-sm text-yellow-800">
            <span className="font-semibold">Note:</span> $20 deposit <span className="font-bold">per person</span> secures your booking. 
            Balance due on trip day.
          </p>
        </div>

        <div className="mt-4 p-4 bg-green-50 rounded-xl">
          <p className="text-sm text-green-800 font-medium">
            Questions? Call (815) 914-8139
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
